export const environment = {
  production: false,
  // apiURL: '/api',
  apiURL: 'https://api.finappli.fr'
};
